export const CONFIG = {
  stage: 'prod',
  baseApiUrl: 'https://api.intenant.io',
  mobileApiKey: 'hUaTWuRpOn8BUlx3f7nYV17yi7rgPETw3Ipj8aRe'
}


export const AWS_CONFIG = {
  Auth: {
    region: 'ap-southeast-2',
    userPoolId: 'ap-southeast-2_dcxp6mx0H',
    userPoolWebClientId: 'h2dfclprjgq70s5msv5539l8j'
  }
}
